import { Button, Card, Form, Input, Typography, message } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import EnterCode from "../controls/enter-code";
import { serverFetch } from "../core/server";
import { sessionFromApi } from "../store/session";
import { setUserSession } from "../store/user-slice";
import "./auth-page.css";

const AuthPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [form] = Form.useForm();
  const [register, setRegister] = useState(searchParams.get("register") === "1");
  const [data, setData] = useState({ email: "", name: "", companyName: "" });
  const [sentCode, setSentCode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [codeId, setCodeId] = useState();

  const onChangeValue = (value) => {
    setData((current) => ({ ...current, ...value }));
  };

  const onSendCode = () => {
    setLoading(true);
    serverFetch("auth/GenerateCheckcode", {
      queryParams: {
        email: data.email,
        register,
        name: data.name,
        companyName: data.companyName
      }
    })
      .then((authCode) => {
        setCodeId(authCode);
        setSentCode(true);
        message.success("Код отправлен на почту");
      })
      .catch((e) => message.error(e.userMessage || e.message || "Не удалось отправить код"))
      .finally(() => setLoading(false));
  };

  const onLogin = (checkcode) => {
    setLoading(true);
    serverFetch("auth/login", {
      method: "POST",
      bodyData: {
        email: data.email,
        checkcode,
        id: codeId
      }
    })
      .then((session) => {
        localStorage.setItem("sessionId", session.sessionId);
        dispatch(setUserSession(sessionFromApi(session)));
        navigate(session.isSuperAdmin && !session.companyId ? "/cabinet/default" : "/cabinet");
      })
      .catch((e) => message.error(e.userMessage || e.message || "Не удалось войти"))
      .finally(() => setLoading(false));
  };

  const changeMode = (isRegister) => {
    setRegister(isRegister);
    setSentCode(false);
    setCodeId(undefined);
    form.resetFields();
    setData({ email: "", name: "", companyName: "" });
  };

  return (
    <div className="auth-page">
      <Card className="auth-card">
        <img className="auth-logo" src="/favicon.svg" alt="" width={48} height={48} />
        <Typography.Title level={3} className="auth-title">
          {register ? "Регистрация" : "Вход"}
        </Typography.Title>
        <Form size="large" form={form} layout="vertical" onFinish={onSendCode}>
          {register && (
            <>
              <Form.Item name="name" rules={[{ required: true, message: "Укажите имя пользователя" }]}>
                <Input
                  placeholder="Имя пользователя"
                  disabled={loading || sentCode}
                  onChange={(e) => onChangeValue({ name: e.target.value })}
                />
              </Form.Item>
              <Form.Item name="companyName" rules={[{ required: true, message: "Укажите название компании" }]}>
                <Input
                  placeholder="Название компании"
                  disabled={loading || sentCode}
                  onChange={(e) => onChangeValue({ companyName: e.target.value })}
                />
              </Form.Item>
            </>
          )}
          <Form.Item
            name="email"
            rules={[
              { required: true, message: "Укажите почту" },
              { type: "email", message: "Некорректная почта" }
            ]}
          >
            <Input
              placeholder="Почта"
              disabled={loading || sentCode}
              onChange={(e) => onChangeValue({ email: e.target.value })}
            />
          </Form.Item>
          {!sentCode && (
            <Form.Item style={{ marginBottom: 0 }}>
              <Button type="primary" htmlType="submit" loading={loading} className="auth-form-btn">
                Отправить код
              </Button>
            </Form.Item>
          )}
          {sentCode && (
            <Form.Item>
              <div className="auth-enter-code-title">Введите код из письма</div>
              <EnterCode len={6} onFinish={onLogin} />
            </Form.Item>
          )}
        </Form>
        <div className="auth-switch">
          {register ? (
            <>
              Уже есть учётная запись?
              <span className="auth-switch-link" onClick={() => changeMode(false)}>
                Войти
              </span>
            </>
          ) : (
            <>
              Нет учётной записи?
              <span className="auth-switch-link" onClick={() => changeMode(true)}>
                Создать
              </span>
            </>
          )}
        </div>
      </Card>
    </div>
  );
};

export default AuthPage;
